import React from 'react';
import {
  Box,
  Button,
  FooterActionBar,
  InputField,
  ModalIsland,
} from '@saviynt/design-system';

import { useInvertedLocalize } from '../../../shared/hooks';

import './SaveToMyReport.css';

interface SaveToMyReportType {
  isOpen: boolean;
  setIsOpen: (value: boolean) => void;
}

/**
 * SaveToMyReport
 */
function SaveToMyReport({ isOpen, setIsOpen }: SaveToMyReportType) {
  const l = useInvertedLocalize();

  const isSubmitButtonEnable = () => true;

  const handleOnClose = () => {
    setIsOpen(false);
  };

  const body = () => (
    <InputField
      name='Name'
      placeholder='My Violations Summary'
      label={<>{l('Name')}</>}
    />
  );

  const handleSubmit = () => {};

  const renderFooter = () => (
    <FooterActionBar size='large' className='SaveToMyReport-footer'>
      <Box tag='div' className='SaveToMyReport-actionButtons'>
        <Button
          type='button'
          kind='ghost'
          size='medium'
          isDisabled={false}
          onClick={handleOnClose}>
          {l('Cancel')}
        </Button>
        <Button
          className='SaveToMyReport-submitButton'
          type='button'
          kind={isSubmitButtonEnable() ? 'filled' : 'outlined'}
          size='medium'
          onClick={handleSubmit}
          isLoading={false}
          loaderText={l('Loading')}>
          {l('Save')}
        </Button>
      </Box>
    </FooterActionBar>
  );

  return (
    <ModalIsland
      onClose={handleOnClose}
      isOpen={isOpen}
      title={l('Save to My Report')}
      subtitle={l(
        'Save the report filters, columns, and sort settings for quick access in the future. Give it a unique name that’s easy to reference.'
      )}
      contentBody={body()}
      FooterActionBarComp={renderFooter()}
      className='SaveToMyReport'
    />
  );
}

export default SaveToMyReport;
